import { render, staticRenderFns } from "./flight.vue?vue&type=template&id=55aa1a7e&scoped=true&"
import script from "./flight.vue?vue&type=script&lang=js&"
export * from "./flight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55aa1a7e",
  null
  
)

export default component.exports